import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Replace with a real logger (Sentry etc.) when ready
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "40px 24px",
        }}>
          <div style={{ fontSize: "3rem", marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontWeight: 700, marginBottom: 12 }}>Something went wrong</h2>
          <p style={{ color: "#64748b", maxWidth: 400, marginBottom: 28 }}>
            We hit an unexpected error. Please refresh the page — if it keeps happening, contact us.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "11px 26px",
              borderRadius: 10,
              border: "none",
              background: "linear-gradient(135deg, #14c9b2, #7c5cbf)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              fontSize: "0.95rem",
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
